import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { PropertyTypeTemplatesComponent } from './property-type-templates.component'
import { CreatePropertyTypeTemplateComponent } from './create-property-type-template/create-property-type-template.component'
import { UpdatePropertyTypeTemplateComponent } from './update-property-type-template/update-property-type-template.component'
import { propertyTypeTemplatesRoutes } from './property-type-templates.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { PropertyTypeModalModule } from '@components/property-type-modal/property-type-modal.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    PropertyTypeTemplatesComponent,
    CreatePropertyTypeTemplateComponent,
    UpdatePropertyTypeTemplateComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(propertyTypeTemplatesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    PropertyTypeModalModule,
    BreadcrumbsModule,
  ],
  exports: [
    PropertyTypeTemplatesComponent,
    CreatePropertyTypeTemplateComponent,
    UpdatePropertyTypeTemplateComponent,
  ],
})
export class PropertyTypeTemplatesModule {}
